module.exports = __webpack_public_path__ + "img/shopify.aa2a6b19.svg";